module.exports = __webpack_public_path__ + "img/3.dffa2b7d.png";